/* eslint-disable no-extra-boolean-cast, no-return-assign, one-var, no-param-reassign, no-undef, prefer-const */
class cartDrawer extends HTMLElement {
  constructor() {
    super()
    this.sectionId = 'cart-drawer-content'
    __THEME_GLOBALS__.cart = document.getElementById('cartDrawer')
    this.drawerOverlay = document.getElementById('js-cart-drawer-overlay')
    this.drawerOpener = document.querySelector('.js-cart-drawer-open')
    this.focusableElements =
      'button, a, input, textarea, select, details, summary, [tabindex]:not([tabindex="-1"])'

    if (!!this.drawerOpener)
      this.drawerOpener.addEventListener('click', this.openDrawer.bind(this))
    if (!!this.drawerOverlay)
      this.drawerOverlay.addEventListener('click', this.closeDrawer.bind(this))

    this.addEventListener('click', (e) => {
      if (e.target.closest('.js-cart-drawer-close')) this.closeDrawer()
      if (e.target.closest('.cart-checkout__button')) this.checkoutEvent(e)
    })
    document.addEventListener('cart:open', () => {
      this.openDrawer()
    })
    document.addEventListener('cart:refresh', () => {
      this.refresh()
    })
    this.checkGwpState(this)
  }

  connectedCallback() {
    document.addEventListener('keydown', this.handleEscapeKey.bind(this))
    this.getCartHeaderHeight()
  }

  disconnectedCallback() {
    document.removeEventListener('keydown', this.handleEscapeKey)
  }

  openDrawer() {
    const attributes = {
      'aria-pressed': 'true',
      'aria-expanded': 'true',
      tabindex: '0',
    }
    __THEME_GLOBALS__.disableScroll()
    this.drawerOverlay.classList.add('is-active')
    __THEME_GLOBALS__.setAttributes(this, attributes)
    this.classList.add('is-visible')
    this.addTrapFocus()
  }

  closeDrawer() {
    const attributes = {
      'aria-pressed': 'false',
      'aria-expanded': 'false',
      tabindex: '-1',
    }
    __THEME_GLOBALS__.enableScroll()
    this.drawerOverlay.classList.remove('is-active')
    __THEME_GLOBALS__.setAttributes(this, attributes)
    this.classList.remove('is-visible')
    this.removeTrapFocus()
  }

  getCartHeaderHeight() {
    const headerDrawer = this.querySelector('#cart-drawer__header')
    document.documentElement.style.setProperty(
      '--cart-header-height',
      `${headerDrawer.offsetHeight}px`
    )
  }

  checkGwpState(html) {
    const headerDrawer = html.querySelector('#cart-drawer__header')
    if (localStorage.getItem('_firstGwp') === 'true')
      headerDrawer.classList.add('hide-gwp-1')
    if (localStorage.getItem('_secondGwp') === 'true')
      headerDrawer.classList.add('hide-gwp-2')
    if (headerDrawer.hasAttribute('data-cart-empty')) {
      headerDrawer.classList.remove('hide-gwp-1', 'hide-gwp-2')
      if (localStorage.getItem('_firstGwp'))
        localStorage.removeItem('_firstGwp')
      if (localStorage.getItem('_secondGwp'))
        localStorage.removeItem('_secondGwp')
    }
  }

  renderContent(responseHtml, sectionId) {
    const cartContent = document.getElementById(sectionId)
    const parseDiv = responseHtml.getElementById(sectionId)
    const cartCount = responseHtml
      .querySelector('[data-cart-count]')
      .getAttribute('data-cart-count')
    this.checkGwpState(parseDiv)
    cartContent.innerHTML = parseDiv.innerHTML
    document
      .querySelectorAll('.js-cart-count')
      .forEach((el) => (el.innerHTML = cartCount))
    // Ensure bundle data is processed
    this.getCartHeaderHeight()
  }

  // All cart events

  async updatePersonalizationProductQuantity(cartLineItems) {
    const { personalizationProduct } = __THEME_GLOBALS__
    const currentPersonalizationLineItem = cartLineItems?.find(
      (item) => item.variant_id === personalizationProduct.variantId
    )

    if (!personalizationProduct?.available) {
      if (currentPersonalizationLineItem) {
        try {
          // remove any old personalization product line item from the cart
          // if personalizationProduct.available is false
          const resp = await fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              sections: this.sectionId,
              sections_url: window.location.pathname,
              id: currentPersonalizationLineItem.key,
              quantity: 0,
            }),
          })
          const json = await resp.json()

          return json
        } catch (error) {
          console.error(error)

          return null
        }
      }

      return null
    }

    if (!currentPersonalizationLineItem) {
      return null
    }

    const customItem = cartLineItems.find(
      (item) =>
        item.properties?.['Personalized Text'] &&
        item.properties?._Personalization === 'yes'
    )
    const updatedPersonalizationQuantity = customItem ? customItem.quantity : 0

    if (
      currentPersonalizationLineItem.quantity === updatedPersonalizationQuantity
    ) {
      return null
    }

    try {
      const resp = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          sections: this.sectionId,
          sections_url: window.location.pathname,
          id: currentPersonalizationLineItem.key,
          quantity: updatedPersonalizationQuantity,
        }),
      })
      const json = await resp.json()

      return json
    } catch (error) {
      console.error(error)

      return null
    }
  }

  cartEvent(url, bodyObj, openDrawer, errorCallback) {
    const config = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest',
      },
    }
    bodyObj = bodyObj || {}
    bodyObj.sections = this.sectionId
    bodyObj.sections_url = window.location.pathname
    config.body = JSON.stringify(bodyObj)

    fetch(`${url}`, config)
      .then((response) => {
        return response.json()
      })
      .then(async (json) => {
        const cartJSON = await this.updatePersonalizationProductQuantity(
          json.items || [json]
        )
        const cart = cartJSON || json
        __THEME_GLOBALS__.cartLineItems = cart.items

        const responseHtml = new DOMParser().parseFromString(
          cart.sections[this.sectionId],
          'text/html'
        )
        this.renderContent(responseHtml, this.sectionId)
        if (openDrawer) this.openDrawer()
      })
      .catch((error) => {
        if (errorCallback) errorCallback(error)
        console.error(error)
      })
  }

  getCartState() {
    return fetch('/cart.js')
      .then((response) => response.json())
      .then((data) => {
        return data
      })
  }

  refresh() {
    fetch(`/cart?section_id=${this.sectionId}`)
      .then((response) => response.text())
      .then((html) => {
        const responseHtml = new DOMParser().parseFromString(html, 'text/html')
        this.renderContent(responseHtml, this.sectionId)
      })
      .catch((error) => console.error('Error fetching cart section:', error))
  }

  // Remove all bundle properties if the bundle is not full
  checkoutEvent(e) {
    e.preventDefault()
    this.updateObj = this.querySelector('[data-checkout-update]')

    if (!this.updateObj) {
      window.location = '/checkout'
    } else {
      const updateData = {
          updates: JSON.parse(
            this.querySelector('[data-checkout-update]').textContent
          ),
        },
        addData = {
          items: JSON.parse(
            this.querySelector('[data-checkout-add]').textContent
          ),
        }
      let configUpdate,
        configAdd,
        headers = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/javascript',
            'X-Requested-With': 'XMLHttpRequest',
          },
        }

      configUpdate = { ...headers }
      configAdd = { ...headers }

      configUpdate.body = JSON.stringify(updateData)
      configAdd.body = JSON.stringify(addData)

      fetch('/cart/update.js', configUpdate)
        .then(() => {
          fetch('/cart/add.js', configAdd)
            .then(() => (window.location = '/checkout'))
            .catch(() => (window.location = '/checkout'))
        })
        .catch(() => (window.location = '/checkout'))
    }
  }

  handleEscapeKey(e) {
    if (this.getAttribute('aria-expanded') !== 'true') return
    if (e.key !== 'Escape') return

    this.closeDrawer()
  }

  addTrapFocus(containerEl) {
    const container = containerEl || this
    container.previousActiveElement = document.activeElement

    container.focusableEls = Array.from(
      container.querySelectorAll(this.focusableElements)
    )

    this.firstFocusableEl = this.focusableEls[0]

    this.lastFocusableEl = this.focusableEls[this.focusableEls.length - 1]

    this.focusableEls.forEach((el) => {
      el.addEventListener('keydown', this.handleFocusTrap.bind(this))
    })
    document.addEventListener('keydown', this.handleFocusTrap.bind(this))

    this.firstFocusableEl?.focus({
      preventScroll: true,
    })
  }

  removeTrapFocus() {
    this.focusableEls?.forEach((el) => {
      el.removeEventListener('keydown', this.handleFocusTrap)
    })

    this.previousActiveElement?.focus({
      preventScroll: true,
    })
  }

  handleFocusTrap(e) {
    if (e.key !== 'Tab') return

    const firstFocusableEl = this.firstFocusableEl
    const lastFocusableEl = this.lastFocusableEl
    const isTabForward = !e.shiftKey
    const isTabBackward = e.shiftKey

    const isFirstElement = document.activeElement === firstFocusableEl
    const isLastElement = document.activeElement === lastFocusableEl

    if ((isTabBackward && isFirstElement) || (isTabForward && isLastElement)) {
      e.preventDefault()
      isTabBackward ? lastFocusableEl.focus() : firstFocusableEl.focus()
    }
  }
}

customElements.define('cart-drawer', cartDrawer)

class cartDrawerContent extends HTMLElement {
  constructor() {
    super()
    this.firstGwp = this.querySelector('[data-first-gwp]')
    this.secondGwp = this.querySelector('[data-second-gwp]')

    if (this.firstGwp) this.gwpEvent(this.firstGwp, '_firstGwp')
    if (this.secondGwp) this.gwpEvent(this.secondGwp, '_secondGwp')
  }

  gwpEvent(obj, gwpProp) {
    const gwp = JSON.parse(obj.textContent)
    if (gwp.action === 'false') return
    if (
      gwp.action === '/cart/add.js' &&
      localStorage.getItem(gwpProp) === 'true'
    )
      return
    let properties = {},
      bodyObj = {
        id: gwp.key,
        quantity: 0,
      }
    if (gwp.action === '/cart/add.js' && !localStorage.getItem(gwpProp)) {
      properties[gwpProp] = true
      bodyObj = {
        id: gwp.id,
        quantity: 1,
        properties,
      }
    }
    __THEME_GLOBALS__.cart.cartEvent(gwp.action, bodyObj, true)
  }
}

customElements.define('cart-drawer-content', cartDrawerContent)

class cartDrawerItem extends HTMLElement {
  constructor() {
    super()
    this.lineItem = JSON.parse(
      this.querySelector('[type="application/json"]').textContent
    )
    this.quantityInput = this.querySelector('.js-quantity')
    this.price = this.querySelector('.cart-item__price')
    this.drawerOpenItemRemovePopup = this.querySelector(
      '[data-action="open-item-remove-popup"]'
    )
    this.drawerRemoveItemPopup = this.querySelector('.js-cart-drawer-popup')

    if (this.quantityInput)
      this.quantityInput.addEventListener(
        'change',
        this.changeQuantity.bind(this)
      )
    this.addEventListener('click', (e) => {
      if (e.target.closest('[data-action="open-item-remove-popup"]'))
        this.openItemRemovePopup()
      if (e.target.closest('[data-action="close-item-remove-popup"]'))
        this.closeItemRemovePopup()
      if (e.target.closest('.js-remove-item-trigger')) this.removeItem()
    })
  }

  changeQuantity() {
    this.price.classList.add('show-loader')
    if (
      Number(this.quantityInput.value) === 0 &&
      this.drawerOpenItemRemovePopup.getAttribute('data-gift-product')
    ) {
      localStorage.setItem(
        this.drawerOpenItemRemovePopup.getAttribute('data-gift-product'),
        'true'
      )
    }
    const bodyObj = {
      id: this.lineItem.key,
      quantity: Number(this.quantityInput.value),
    }
    __THEME_GLOBALS__.cart.cartEvent('/cart/change.js', bodyObj, true)
  }

  openItemRemovePopup() {
    const attrObj = {
      'aria-expanded': 'true',
      'aria-hidden': 'false',
      tabindex: '0',
    }
    __THEME_GLOBALS__.setAttributes(this.drawerRemoveItemPopup, attrObj)
  }

  closeItemRemovePopup() {
    const attrObj = {
      'aria-expanded': 'false',
      'aria-hidden': 'true',
      tabindex: '-1',
    }
    __THEME_GLOBALS__.setAttributes(this.drawerRemoveItemPopup, attrObj)
  }

  async removeItem() {
    const cart = await __THEME_GLOBALS__.cart.getCartState()
    const { items } = cart
    const lineItem = items.find(
      (item) =>
        item.id === this.lineItem.id &&
        this.lineItem.properties._bundle_uid !== null &&
        item.properties._bundle_uid === this.lineItem.properties._bundle_uid
    )
    const bodyObj = {
      id: lineItem.key,
      quantity: 0,
    }
    if (this.drawerOpenItemRemovePopup.getAttribute('data-gift-product')) {
      localStorage.setItem(
        this.drawerOpenItemRemovePopup.getAttribute('data-gift-product'),
        'true'
      )
    }
    if (this.hasAttribute('data-cart-gift-note'))
      bodyObj.attributes = { 'Gift note': '' }
    __THEME_GLOBALS__.cart.cartEvent('/cart/change.js', bodyObj, true)

    this.closeItemRemovePopup()
  }
}

customElements.define('cart-drawer-item', cartDrawerItem)

class cartRecommendedProduct extends ProductCard {
  constructor() {
    super()
    this.atcBtn = this.querySelector('[data-action="add-to-cart-recommended"]')

    this.colorSelectors.forEach((option) => {
      option.addEventListener('click', () => {
        this.atcBtn.setAttribute(
          'data-variant-id',
          option.getAttribute('data-variant-id')
        )
      })
    })

    this.atcBtn.addEventListener('click', (e) => {
      this.addRecommendedProduct(e)
    })
  }

  addRecommendedProduct(e) {
    e.preventDefault()
    const bodyObj = {
      id: this.atcBtn.getAttribute('data-variant-id'),
      quantity: 1,
    }
    __THEME_GLOBALS__.cart.cartEvent(
      '/cart/add.js',
      bodyObj,
      true,
      this.errorCallback
    )
  }

  errorCallback(error) {
    const errorMessage = document.querySelector('#CartRecommendedErrorMessage')
    errorMessage.innerHTML = error.responseJSON.description
    errorMessage.style.display = 'block'
    setTimeout(() => {
      errorMessage.style.display = 'none'
      errorMessage.innerHTML = ''
    }, 3500)
  }
}

customElements.define('cart-recommended-product', cartRecommendedProduct)

class cartGiftWrapping extends HTMLElement {
  constructor() {
    super()
    this.giftWrappingModal = this.querySelector('.cart-gift-wrapping-modal')
    this.addWrappingBtn = this.querySelector('[data-add-gift-note]')
    this.noteArea = this.querySelector('#cart-note')
    this.noteLength = this.querySelector('.note-length')
    this.giftBoxInCart = this.getAttribute('data-gift-box-in-cart')

    if (this.addWrappingBtn)
      this.addWrappingBtn.addEventListener(
        'click',
        this.changeGiftWrappingNote.bind(this)
      )
    document.addEventListener('click', (e) => {
      if (e.target.closest('[data-gift-note-trigger]'))
        this.triggerGiftWrappingModal()
    })
    this.addEventListener('input', this.checkNoteLength.bind(this))
  }

  triggerGiftWrappingModal() {
    const wrappingModalStatus =
        this.giftWrappingModal.getAttribute('aria-expanded'),
      triggerAttr = wrappingModalStatus === 'false' ? 'true' : 'false'
    this.giftWrappingModal.setAttribute('aria-expanded', triggerAttr)
    if (wrappingModalStatus === 'false') {
      this.addTrapFocus()
    } else this.removeTrapFocus()
  }

  checkNoteLength() {
    const maxLength = this.noteArea.getAttribute('maxlength'),
      currentLength = this.noteArea.value.length
    this.noteLength.innerHTML = `${
      maxLength - currentLength
    } Characters Remaining`
  }

  changeGiftWrappingNote() {
    const bodyObj = {
      attributes: {
        'Gift note': this.noteArea.value,
      },
    }

    if (this.giftBoxInCart === 'false') {
      bodyObj.id = window.__THEME_GLOBALS__.giftWrapping.giftWrappingProductID
      bodyObj.quantity = 1
      __THEME_GLOBALS__.cart.cartEvent('/cart/add.js', bodyObj, true)
    } else {
      __THEME_GLOBALS__.cart.cartEvent('/cart/update.js', bodyObj, true)
    }
  }
}

customElements.define('cart-gift-wrapping', cartGiftWrapping)

class CartRecommendations extends HTMLElement {
  connectedCallback() {
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this)
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return
    observer.unobserve(this)

    fetch(this.dataset.url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div')
        html.innerHTML = text
        const recommendations = html.querySelector(
          'cart-dynamic-recommendations'
        )
        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML
        } else {
          const defaultElement = document.querySelector(
            '[data-cart-recommended-default]'
          )
          if (defaultElement) {
            defaultElement.classList.remove('hidden')
          }
        }
      })
      .catch((e) => {
        console.error(e)
      })
  }
}
customElements.define('cart-dynamic-recommendations', CartRecommendations)
// data-cart-recommended-default
